module.exports = __webpack_public_path__ + "static/media/DCR.b6a7e26c.svg";